<div class="w-full flex flex-col flex-1 min-h-0">
<div class="flex flex-col flex-1 min-h-0 overflow-hidden">

  @if (loading() && !initialLoadDone()) {
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <p-skeleton width="8rem" height="1.5rem" class="mb-2" />
            <p-skeleton width="14rem" height="0.875rem" />
          </div>
          <div class="w-full sm:w-auto flex justify-end">
            <p-skeleton width="10rem" height="2.5rem" />
          </div>
        </div>
      </div>
      <div class="flex-1 min-h-0 overflow-auto">
        <table class="w-full border-collapse">
          <thead class="bg-slate-50 border-b border-slate-200">
            <tr>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Entidad</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Operación</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600 hidden sm:table-cell">Autor</th>
              <th class="px-2 py-2 text-center text-sm font-semibold text-slate-600">Fecha</th>
              <th class="px-2 py-2 text-right text-sm font-semibold text-slate-600">Acciones</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-slate-100">
            @for (row of skeletonRows; track row) {
              <tr>
                <td class="px-2 py-2">
                  <div class="flex items-center gap-2">
                    <p-skeleton shape="circle" size="2.5rem" />
                    <div class="min-w-0">
                      <p-skeleton width="7rem" height="0.875rem" />
                      <p-skeleton width="5rem" height="0.75rem" class="mt-1" />
                    </div>
                  </div>
                </td>
                <td class="px-2 py-2"><p-skeleton width="4rem" height="1.25rem" /></td>
                <td class="px-2 py-2 hidden sm:table-cell"><p-skeleton width="8rem" height="0.875rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="5rem" height="0.875rem" /></td>
                <td class="px-2 py-2 text-right"><p-skeleton width="4rem" height="2rem" /></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="bg-slate-50 px-6 py-4 border-t border-slate-200 flex justify-end shrink-0">
        <p-skeleton width="12rem" height="2rem" />
      </div>
    </div>
  }

  @if (error() && !loading()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <div class="flex items-center">
        <mat-icon class="text-red-600 mr-2">error</mat-icon>
        <p class="text-red-800">{{ error() }}</p>
      </div>
      <button
        (click)="loadChanges()"
        class="mt-3 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
        Reintentar
      </button>
    </div>
  }

  @if (initialLoadDone() && !error()) {
    <div class="flex-1 min-h-0 flex flex-col">
      <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
                <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-rose-100 text-rose-600">
                  <i class="pi pi-history"></i>
                </span>
                Auditoría
              </h2>
              <p class="text-sm text-slate-500 mt-1">Últimos cambios registrados en el sistema.</p>
            </div>
            <div class="w-full sm:w-auto flex flex-wrap items-center justify-end gap-2">
              <p-button
                label="Actualizar"
                icon="pi pi-refresh"
                severity="secondary"
                size="small"
                [rounded]="true"
                [loading]="loading()"
                (onClick)="refreshTable()"
                pTooltip="Actualizar listado con los filtros y página actuales"
                tooltipPosition="left"
                appendTo="body" />
            </div>
          </div>
        </div>

        <div [formGroup]="filtersForm" class="border-b border-slate-200 bg-slate-50 shrink-0 px-3 py-2">
          <div class="grid grid-cols-2 xl:flex xl:flex-wrap xl:items-end gap-2">
            <p-floatlabel class="w-full min-w-0 xl:w-44" variant="on">
              <p-select
                formControlName="entityType"
                inputId="filterAuditEntityType"
                [options]="entityFilterOptions"
                optionLabel="label"
                optionValue="value"
                size="small"
                [showClear]="true"
                class="w-full" />
              <label for="filterAuditEntityType">Entidad</label>
            </p-floatlabel>
            <div class="min-w-0 xl:w-28">
              <p-floatlabel class="w-full" variant="on">
                <p-iconfield class="w-full">
                  <input
                    pInputText
                    id="filterAuditEntityId"
                    formControlName="entityId"
                    class="w-full p-inputtext-sm"
                    inputmode="numeric"
                    autocomplete="off" />
                  @if (filtersForm.controls.entityId.value) {
                    <p-inputicon
                      class="pi pi-times text-sm cursor-pointer"
                      (click)="filtersForm.controls.entityId.setValue('', { emitEvent: false }); applyFilters()" />
                  }
                </p-iconfield>
                <label for="filterAuditEntityId">ID</label>
              </p-floatlabel>
            </div>
            <div class="min-w-0 col-span-2 sm:col-span-1 xl:w-72">
              <p-floatlabel class="w-full" variant="on">
                <p-autocomplete
                  inputId="filterAuditUser"
                  formControlName="userSelection"
                  [suggestions]="userFilterOptions()"
                  (completeMethod)="onUserFilterSearch($event)"
                  (onSelect)="onUserFilterSelect($event.value)"
                  (onClear)="onUserFilterSelect(null)"
                  optionLabel="displayLabel"
                  [minLength]="3"
                  [delay]="1000"
                  [showClear]="true"
                  appendTo="body"
                  size="small"
                  styleClass="w-full"
                  fluid />
                <label for="filterAuditUser">Usuario</label>
              </p-floatlabel>
            </div>
            <div class="min-w-0 col-span-2 sm:col-span-1 xl:w-62">
              <p-floatlabel class="w-full" variant="on">
                <p-datepicker
                  inputId="filterAuditCommitDate"
                  formControlName="commitDateRange"
                  selectionMode="range"
                  [readonlyInput]="true"
                  dateFormat="dd/mm/yy"
                  showIcon
                  iconDisplay="input"
                  [showClear]="true"
                  size="small"
                  appendTo="body"
                  class="w-full" />
                <label for="filterAuditCommitDate">Rango de fecha</label>
              </p-floatlabel>
            </div>
            @if (hasActiveFilters()) {
              <div class="flex items-end col-span-2 sm:col-span-1">
                <p-button
                  icon="pi pi-times"
                  [rounded]="true"
                  [text]="true"
                  size="small"
                  severity="secondary"
                  type="button"
                  (onClick)="clearFilters()"
                  ariaLabel="Limpiar filtros" />
              </div>
            }
          </div>
        </div>

        <div class="flex-1 min-h-0 overflow-hidden">
          <p-table
            [value]="changes()"
            dataKey="commitId"
            [lazy]="true"
            [scrollable]="true"
            scrollHeight="flex"
            [totalRecords]="totalItems()"
            [first]="currentPage() * pageSize()"
            [rows]="pageSize()"
            [rowsPerPageOptions]="pageSizeOptions"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} cambios"
            [loading]="loading()"
            [paginator]="true"
            (onLazyLoad)="onLazyLoad($event)"
            [tableStyle]="{ width: '100%' }"
            styleClass="audit-primeng-table p-datatable-striped p-datatable-sm"
            [rowHover]="true"
            paginatorStyleClass="!border-0 !bg-transparent !pt-4 !flex !justify-end">
            <ng-template pTemplate="header">
              <tr>
                <th class="!px-2">Entidad</th>
                <th class="!px-2 !whitespace-nowrap">Operación</th>
                <th class="!px-2 hidden sm:table-cell !whitespace-nowrap">Autor</th>
                <th class="!px-2 !whitespace-nowrap !text-center">Fecha</th>
                <th class="!px-2 !whitespace-nowrap !text-right">Acciones</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-change>
              <tr
                class="cursor-pointer hover:!bg-sky-50/50 transition-colors !border-slate-100"
                (click)="openCompare(change)">
                <td class="!px-2 !py-2 !border-slate-100">
                  <div class="flex items-center gap-2">
                    <div
                      class="shrink-0 h-8 w-8 rounded-full flex items-center justify-center [&>i]:text-sm"
                      [ngClass]="entityColorClasses(change.entityType)">
                      <i [class]="entityIcon(change.entityType)"></i>
                    </div>
                    <div class="min-w-0">
                      <div class="text-sm font-medium text-slate-900 truncate">{{ entityLabel(change.entityType) }}</div>
                      <div class="text-xs text-slate-500 truncate">
                        ID {{ change.entityId ?? '—' }}
                        @if (change.version != null) {
                          · v{{ change.version }}
                        }
                      </div>
                    </div>
                  </div>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 !whitespace-nowrap">
                  <p-tag
                    class="!text-xs"
                    [value]="operationLabel(change.operation)"
                    [severity]="operationSeverity(change.operation)" />
                </td>
                <td class="!px-2 !py-2 !border-slate-100 hidden sm:table-cell text-sm text-slate-600 !whitespace-nowrap">
                  {{ change.author || '—' }}
                </td>
                <td class="!px-2 !py-2 !border-slate-100 !whitespace-nowrap !text-center">
                  @if (change.commitDate) {
                    <div class="text-sm text-slate-600">{{ change.commitDate | date:'dd/MM/yyyy' }}</div>
                    <div class="text-[11px] text-slate-400 mt-0.5">{{ change.commitDate | date:'h:mm a' }}</div>
                  } @else {
                    <span class="text-sm text-slate-600">—</span>
                  }
                </td>
                <td class="!px-2 !py-2 !border-slate-100 !text-right !whitespace-nowrap" (click)="$event.stopPropagation()">
                  <p-button
                    icon="pi pi-ellipsis-v"
                    rounded
                    [text]="true"
                    severity="secondary"
                    styleClass="hover:!bg-sky-100"
                    (onClick)="openRowMenu($event, rowMenu, change)" />
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5" class="!px-2 !py-12 !text-center !text-slate-500 !border-slate-100">
                  No se encontraron cambios con los filtros aplicados.
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  }

</div>

<p-menu #rowMenu [model]="rowMenuItems()" [popup]="true" appendTo="body" />

<p-drawer
  [visible]="drawerOpen()"
  position="right"
  (visibleChange)="onDrawerVisibleChange($event)"
  styleClass="audit-json-drawer !w-[min(92vw,72rem)]"
  [blockScroll]="true">
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full gap-3">
      <div class="flex items-center gap-3 min-w-0">
        <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-rose-100 text-rose-600 shadow-sm">
          <i class="pi pi-history text-base"></i>
        </span>
        <div class="min-w-0">
          <h3 class="text-lg font-semibold text-slate-900 flex items-center gap-2 flex-wrap">
            Comparación de versión
            @if (compare()?.version != null || selectedChange()?.version != null) {
              <span class="inline-flex items-center rounded-md bg-slate-200/80 px-2 py-0.5 text-xs font-semibold text-slate-700">
                v{{ compare()?.version ?? selectedChange()?.version }}
              </span>
            }
          </h3>
          @if (compare() || selectedChange(); as change) {
            <p class="text-xs text-slate-500 truncate">
              {{ entityLabel(selectedChange()?.entityType) }}
              #{{ selectedChange()?.entityId ?? '—' }}
              · {{ operationLabel(change.operation) }}
              · {{ change.author || '—' }}
              · {{ change.commitDate ? (change.commitDate | date:'dd/MM/yyyy HH:mm') : '—' }}
            </p>
          }
        </div>
      </div>
      <div class="flex items-center gap-1 shrink-0">
        <p-button
          type="button"
          icon="pi pi-chevron-left"
          [rounded]="true"
          [text]="true"
          severity="secondary"
          size="small"
          [disabled]="compareLoading() || !canGoOlderVersion()"
          (onClick)="goToPreviousVersion()"
          pTooltip="Versión anterior"
          tooltipPosition="bottom"
          appendTo="body" />
        <p-button
          type="button"
          icon="pi pi-chevron-right"
          [rounded]="true"
          [text]="true"
          severity="secondary"
          size="small"
          [disabled]="compareLoading() || !canGoNewerVersion()"
          (onClick)="goToNextVersion()"
          pTooltip="Versión siguiente"
          tooltipPosition="bottom"
          appendTo="body" />
        <p-button
          type="button"
          label="Copiar JSON"
          icon="pi pi-copy"
          [outlined]="true"
          size="small"
          class="ml-1"
          (onClick)="copyJson()" />
      </div>
    </div>
  </ng-template>
  @if (compareLoading()) {
    <div class="flex flex-col items-center justify-center py-12 gap-4">
      <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
      <p class="text-sm text-slate-600">Comparando con la versión anterior...</p>
    </div>
  } @else if (compare(); as compareResult) {
    <app-json-viewer
      [data]="compareResult.document"
      [previous]="compareResult.previousDocument" />
  }
</p-drawer>
</div>
